import React, { PureComponent } from 'react';
import _ from 'lodash'
import {
  Card, CardBody, Col, Button, ButtonToolbar, Container, Row, Table, Modal
} from 'reactstrap';
import { Field, reduxForm } from 'redux-form';
import './styles.css';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import XLSX from 'xlsx';
import { MDBDataTable } from 'mdbreact';
import * as FileSaver from 'file-saver';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import Util from '../../../Common/util';
import API from '../../../Common/api';

import './styles.css';
import LoadingOverlay from 'react-loading-overlay';
import styled, { ThemeProvider, css } from "styled-components";
import DatePicker from "react-datepicker";
import Carousel from "react-multi-carousel";


const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4,
    paritialVisibilityGutter: 60
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2,
    paritialVisibilityGutter: 50
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
    paritialVisibilityGutter: 30
  }
};
const DarkBackground = styled.div`
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  overflow: auto; /* Enable scroll if needed */
  background-color: rgb(0, 0, 0); /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */

  ${(props) =>
    props.disappear &&
    css`
      display: block; /* show */
    `}
`;


var url = window.location.hostname;
var port = window.location.port;
var From_Date_val;
var to_Date_val;



const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const fileExtension = '.xls';

const exportToCSV = (csvData,fileName) => {
  // const ws = XLSX.utils.json_to_sheet(csvData);
  const Heading = [['Warehouse', 'Brand','Product Code','Total System Qty',	'Total Scan qty',	'Total Short', 'Total Excess',	'Adjusted Value'
]];
  const ws = XLSX.utils.json_to_sheet(csvData,{ origin: 'A2', skipHeader: true });
  XLSX.utils.sheet_add_aoa(ws, Heading, { origin: 'A1' });
  const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
  const excelBuffer = XLSX.write(wb, { bookType: 'xls', type: 'array' });
  const data = new Blob([excelBuffer], {type: fileType});
  FileSaver.saveAs(data, fileName + fileExtension);
}


class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.createCookie = this.createCookie.bind(this);
    this.accessCookie = this.accessCookie.bind(this);
    this.fetchCycleCountData = this.fetchCycleCountData.bind(this);
    this.indexOfExt = this.indexOfExt.bind(this);
    this.processData = this.processData.bind(this);

    this.state = {
      loading_overlay: false,
      showPassword: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      warehouseData: [],
      cityData: [],
      clientData: [],
      brand_code: "",
      warehouse_code: "",
      showInvalidItem: false,
      fileNameVal: 'masterFile',
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      posts: [],
      ErrorRowData: [],
      loading: false,
      invoice_no : "",
      trip_id : "",
      product_code : "",
      short_percentage: "0",
      short_value: "0",
      excess_percentage: "0",
      excess_value: "0",
      national_percentage: "0",
      national_value: "0",

      isLoading: true,
      showFetchBinData: true,
      show_process_data: true,

      from_date: "",
      to_date: "",
      mrp : "",

      tableRows: [],
      value: '',
      error: '',
      value: 'select',
      selectedFileType: '',
      orderData : [],
      batch_id : "",
      from_date: null,
      to_date: null,
      showFromErr: false,
      showToErr: false,
      dateRangeError: false, 
      toDateError: "",
      fromDateError: ""

    };
  }


  showPassword = (e) => {
    e.preventDefault();
    this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  };

  componentDidMount() {
    // this.fetchInventoryData();
    this.getFilterData();
    this.getTilesData();
  }


  componentWillMount() {

    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090"
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088"
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";

    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = this.getCookie('token');
    var location = this.getCookie('selectedLocation');
    var username = this.accessCookie("token");
    this.setState({
      userName: cookieUsername,
      selectedLocation: location
    })

    localStorage.setItem('userName', username);
  }

  createCookie(cookieName, cookieValue, daysToExpire) {
    var date = new Date();
    date.setTime(date.getTime() + (1 * 24 * 60 * 60 * 1000));
    document.cookie = cookieName + "=" + cookieValue + "; expires=" + date.toGMTString();
  }

  accessCookie(cookieName) {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(';');
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  indexOfExt(list, item) {
    var len = list.length;

    for (var i = 0; i < len; i++) {
      var keys = Object.keys(list[i]);
      var flg = true;
      for (var j = 0; j < keys.length; j++) {
        var value = list[i][keys[j]];
        if (item[keys[j]] !== value) {
          flg = false;
        }
      }
      if (flg == true) {
        return i;
      }
    }
    return -1;
  }

   getTilesData = ()=>{
    
    API.get('/mis/fetchMTDVarianceData')

      .then((response) => response.data)
      .then((data) => {
        
        this.setState({
          excess_percentage: data.excess_data.excess_percentage,
          excess_value: data.excess_data.total_excess_value,
          short_percentage: data.short_data.short_percentage,
         short_value: data.short_data.total_short_value,
          national_percentage: data.national_data.diff_percentage,
          national_value: data.national_data.total_value,

        },() => {
          
        });

      })
      .catch(function (error) { });
  }

  getFilterData = ()=>{
    
    API.get('/mis/varianceDataFilters')

      .then((response) => response.data)
      .then((data) => {

        this.setState({
          cityData: data.city,
          warehouseData: data.warehouse,
          clientData: data.brand
        })


      })
      .catch(function (error) { });
  }

  convertDate = (inputFormat) => {
    function pad(s) { return (s < 10) ? '0' + s : s; }
    var d = new Date(inputFormat)
    return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-')
  }

  FromDateChange = date => {
    this.setState({
      from_date: date,
      dateRangeError: false, // Reset the error when "From Date" changes
      dateOrderError: false, // Reset the date order error
    });

    if (date) {
      From_Date_val = this.convertDate(date);
    } else {
      this.setState({ to_date: "" });
      From_Date_val = "";
    }


    if (this.state.to_date && date) {
      const fromDate = new Date(date);
      const toDate = new Date(this.state.to_date);
      const timeDifference = toDate - fromDate;
      const dayDifference = timeDifference / (1000 * 3600 * 24); // Convert to days

      // If the difference is less than 15 days, show error
       if (fromDate > toDate) {
        // If From Date is greater than To Date, show error
        this.setState({
          dateOrderError: true,
           from_date: null, 
           todateError: "",
           fromDateError: "From Date should be less than To Date"
        });
      }
      console.log("dateOrderError",dayDifference)
      if (dayDifference > 15) {
        this.setState({
          dateOrderError: true, // Show error if the date range is less than 15 days
          from_date: null, // Reset From Date if the range is invalid
          fromDateError: "From Date should always be within 15 days of the To Date"
        });
      }
    }
  };

  // To date change handler
  ToDateChange = date => {
    if (date && this.state.from_date) {
      const fromDate = new Date(this.state.from_date);
      const toDate = new Date(date);
      const timeDifference = toDate - fromDate;
      const dayDifference = timeDifference / (1000 * 3600 * 24);
      if (fromDate > toDate) {
        // If From Date is greater than To Date, show error
        console.log("fromDate", fromDate, "toDate", toDate)
        this.setState({
          dateRangeError: true,
           to_date: null, 
           todateError: "",
           toDateError: "To Date should be greater than From Date"
        });
        return false;
      }

      if (dayDifference > 15) {
        this.setState({
          dateRangeError: true,
          toDateError: "You cannot select more than 15 days",
          to_date: null, // Reset to_date if range exceeds 15 days
        });
      } else {
        this.setState({
          to_date: date,
          showToErr: false,
          dateRangeError: false,
        });
      }
    } else {
      this.setState({
        to_date: date,
        showToErr: false,
        dateRangeError: false,
      });
    }

    if (date) {
      to_Date_val = this.convertDate(date);
    } else {
      this.setState({ to_date: "" });
      to_Date_val = "";
    }
  };
  onHandleChange = (evt)=>{
    this.setState({[evt.target.name]: evt.target.value})
  }
  onMrpChange = (evt) => {
    this.setState({
      mrp : evt.target.value,
    });
  };
  
  onProductChange = (evt) => {
    this.setState({
      product_code : evt.target.value,
    });
  };
  onBatchChange = (evt)=>{
    this.setState({
      batch_id : evt.target.value,
    })
  }

  onwarehouseChange = (evt) =>{

    this.setState({
      warehouse_code : evt.target.value
    })

  }

  onBrandChange = (evt) =>{

    this.setState({
      brand_code : evt.target.value
    })

  }


  fetchWarehouseData = () =>{

    const payload = {
      

    };

    API.post('/product/product_master/v1/warehouse/dropdown/', { param: payload })

      .then((response) => response.data)
      .then((data) => {

        this.setState({
          //showFetchDispatchData: true,
          warehouseData: data.data,
          loading: false
        });

      })
      .catch(function (error) { });

  }

  fetchBrandData = () =>{

    const payload = {
      

    };

    API.post('/product/product_master/v1/client/dropdown/', { param: payload })

      .then((response) => response.data)
      .then((data) => {

        this.setState({
          //showFetchDispatchData: true,
          clientData: data.data,
          loading: false
        });

      })
      .catch(function (error) { });

  }

  downloadExcel = ()=>{

     const queryParams = {};
    queryParams.request_type = 1

     if (From_Date_val !== null && From_Date_val !== undefined && From_Date_val !== "") {
      queryParams.from_date = From_Date_val;
    }


    if (to_Date_val !== null && to_Date_val !== undefined && to_Date_val !== "")  {
      queryParams.to_date = to_Date_val;
    }

    // Check if param3 is not null or undefined, and add it to queryParams
    if (this.state.city !== null && this.state.city !== undefined && this.state.city !== "") {
      queryParams.city = this.state.city;
    }

     if (this.state.warehouse !== null && this.state.warehouse !== undefined && this.state.warehouse !== "") {
      queryParams.warehouse = this.state.warehouse;
    }

    if (this.state.brand !== null && this.state.brand !== undefined && this.state.brand !== "") {
      queryParams.brand = this.state.brand;
    }

    const queryString = Object.keys(queryParams)
      .map((key) => `${key}=${encodeURIComponent(queryParams[key])}`)
      .join('&');
  
    API.get('/mis/fetchVarianceData?'+ queryString)
      .then(response => response.data)

      .then(data => {

        exportToCSV(data, "cycle count variance report")

      })

      .then(async () => {     

      });

  }

  fetchCycleCountData() {
    this.setState({
      showFetchBinData: true,
      showFetchBaseData: false,
      showFetchProductData: false,
      showFetchTesterData: false,
      loading_overlay: true
    })

    const queryParams = {};
    queryParams.request_type = 0

     if (From_Date_val !== null && From_Date_val !== undefined && From_Date_val !== "") {
      queryParams.from_date = From_Date_val;
    }

    if (to_Date_val !== null && to_Date_val !== undefined && to_Date_val !== "")  {
      queryParams.to_date = to_Date_val;
    }

    // Check if param3 is not null or undefined, and add it to queryParams
    if (this.state.city !== null && this.state.city !== undefined && this.state.city !== "") {
      queryParams.city = this.state.city;
    }

     if (this.state.warehouse !== null && this.state.warehouse !== undefined && this.state.warehouse !== "") {
      queryParams.warehouse = this.state.warehouse;
    }

    if (this.state.brand !== null && this.state.brand !== undefined && this.state.brand !== "") {
      queryParams.brand = this.state.brand;
    }

    const queryString = Object.keys(queryParams)
      .map((key) => `${key}=${encodeURIComponent(queryParams[key])}`)
      .join('&');

   
    API.get('/mis/fetchVarianceData?'+ queryString)
      .then(response => response.data)

      .then(data => {
      
        this.setState({ tableRows: this.assemblePosts(data)})

      })

      .then(async () => {

        this.setState({  isLoading: false ,loading_overlay: false})

      });
  }
  filterData = (evt) => {
    if (evt == "") {
      this.setState({ filtered_orderData: this.state.orderData});
    } else {
      
      var value = this.state.orderData.filter(
        (val) =>{
        return Object.keys(val).some(key =>{
          var data = ""
          if (val[key] == null ) {
            data = ""
          } 
          else {
            data = val[key]
          }
          
          return data.toString().toLowerCase().includes(evt.toLowerCase()) 
        })
        }
        );
      
        this.setState({
          filtered_orderData: value,
        });
      }
    };

  assemblePosts = (data) => {

    let posts = data.map((post) => {
      var status = ""
      if (post.status == true) {
        status = "Active"
      } else { status = " Not Active" }
      return (

        {
          warehouse: post.warehouse_code,
          client: post.brand,
          product_code:post.product_code,
          system_qty: post.sys_qty,
          scanned_qty: post.scan_qty,	
         
          total_short: post.total_short,
          total_excess: post.total_excess,
           adjusted_value: post.adjusted_value, 
          

        }

      )

    });

    this.setState({
      loading_overlay: false,
      posts: posts ,
      orderData : posts,
      filtered_orderData : posts
    })

    return posts;

  }

  processData() {

    this.setState({
      loading: true
    })

  }

  render() {

    const data = {

      columns: [
        {
          label: 'Warehouse',
          field: 'warehouse',
          sort: 'asc',
          width: 120,

        },
        {
          label: 'Brand',
          field: 'client',
          sort: 'asc',
          width: 120,

        },
       
        {
          label: 'System Qty',
          field: 'system_qty',
          width: 110,
          sort: 'asc',

        },
        {

          label: 'Scanned Qty',
          field: 'scanned_qty',
          width: 110,
          sort: 'asc',

        },

        {
          label: 'Total Short',
          field: 'total_short',
          width: 120,
          sort: 'asc',

        },

         {
          label: 'Total Excess',
          field: 'total_excess',
          width: 120,
          sort: 'asc',

        },

        {
          label: 'Adjusted Value',
          field: 'adjusted_value',
          width: 120,
          sort: 'asc',

        },
             

      ],

      rows: this.state.tableRows,

    }
    return (
      <Col xl={12}>
        {this.state.loading_overlay && (
          <DarkBackground disappear={this.state.loading_overlay}>

            <LoadingOverlay
              active={this.state.loading_overlay}
              // spinner={<BounceLoader />}
              spinner={this.state.loading_overlay}
              text={this.state.loadingText}
              style={{ textAlign: "center", alignItem: "center" }}
            >
              {/* <p>Some content or children or something.</p> */}
            </LoadingOverlay>
          </DarkBackground>
        )}
        <Card>

            <CardBody style={{ marginTop: 2, paddingTop: 40, paddingBottom: 0 }}>
              {/*<hr style={{marginTop:'30px',marginBottom:'0px'}}/>*/}
              <div
                className="dispatchData stock_check_data"
                style={{ marginTop: -27 }}
              >
                  <Carousel
      ssr
      partialVisbile
      
      itemClass="image-item"
      responsive={responsive}
    >
  
        
          <div style={{ width: "96%", height: "100%", padding: 20,   backgroundColor: '#d0e8fc', borderRadius: 12 }}>
          
                 <div style={{backgroundColor: '#d0e8fc', textAlign: 'center'}}>
            <span style={{fontSize: 18, textAlign: 'center', fontWeight: 'bold'}}> Total Short </span><br/>
            <span style={{fontSize: 16, textAlign: 'center', fontWeight: 'Normal'}}><span> {this.state.short_percentage}(%)</span> <span style={{marginLeft: 8}}> {this.state.short_value} (lacs) </span> </span><br/>
            </div>
      
         
           
            
          </div>

            <div style={{ width: "96%", height: "100%", padding: 20,   backgroundColor: '#d0e8fc', borderRadius: 12 }}>
          
                 <div style={{backgroundColor: '#d0e8fc', textAlign: 'center'}}>
            <span style={{fontSize: 18, textAlign: 'center', fontWeight: 'bold'}}> National Variance </span><br/>
            <span style={{fontSize: 16, textAlign: 'center', fontWeight: 'Normal'}}><span> {this.state.national_percentage} (%)</span> <span style={{marginLeft: 8}}> {this.state.national_value} (lacs) </span> </span><br/>
            </div>
            </div>

            <div style={{ width: "96%", height: "100%", padding: 20,   backgroundColor: '#d0e8fc', borderRadius: 12 }}>
          
                 <div style={{backgroundColor: '#d0e8fc', textAlign: 'center'}}>
            <span style={{fontSize: 18, textAlign: 'center', fontWeight: 'bold'}}> Total Excess </span><br/>
            <span style={{fontSize: 16, textAlign: 'center', fontWeight: 'Normal'}}><span> {this.state.excess_percentage}(%)</span> <span style={{marginLeft: 8}}> {this.state.excess_value} (lacs) </span> </span><br/>
            </div>
      
         
           
            
          </div>
     
    </Carousel>
              </div>
            </CardBody>
          
        <CardBody style={{ paddingTop: 5, height: 100, marginTop : "-20px",paddingBottom: 0 }}>
          <form className="form" >

            <div style={{ width: '12%', marginBottom: '0px', float: 'left', marginRight: 5 }}>

              <DatePicker
                selected={this.state.from_date}
                onChange={this.FromDateChange}
                className="ledger_fromdate"
                placeholderText="From Date"
                format='yyyy-MM-dd'

              />

              {this.state.showFromErr &&
                <span style={{ color: 'red', fontSize: 11 }}>Please Select From Date</span>
              }
              {this.state.dateOrderError && (
                  <span style={{ color: 'red', fontSize: 11 }}>{this.state.fromDateError}</span>
              )}
            </div>

            <div style={{ width: '12%', marginBottom: '0px', float: 'left', marginRight: 5 }}>
              <DatePicker
                selected={this.state.to_date}
                onChange={this.ToDateChange}
                className="ledger_todate"
                placeholderText="To Date"
              />
              {this.state.showToErr &&
                <span style={{ color: 'red', fontSize: 11 }}>Please Select To Date</span>
              }

              {this.state.dateRangeError &&
                  <span style={{ color: 'red', fontSize: 11 }}>{this.state.toDateError}</span>
                }


            </div>

             <div
                style={{ width: '13%', marginBottom: '0px', float: 'left', marginRight: 20, }}
              >
                <div
                  className="form__form-group-field"

                >
               <select
                    className="form-control"
                    style={{ fontSize: 13,  width: 190 }}
                    onChange={this.onHandleChange}
                    name="city"
                  >
                    <option value="">Select City</option>
                    {
                      this.state.cityData.length > 0 &&
                      this.state.cityData.map((city) => {
                        return (
                          <option value={city}>{city} </option>
                        );
                      })}
                  </select>
                  </div>
                  </div>
           
          

               <div
                style={{ width: '14%', marginBottom: '0px', float: 'left', marginRight: 20, }}
              >
                <div
                  className="form__form-group-field"

                >
               <select
                    className="form-control"
                    style={{ fontSize: 13,  width: 190 }}
                    onChange={this.onHandleChange}
                    name="warehouse"
                  >
                    <option value="">Select warehouse</option>
                    {
                      this.state.warehouseData.length > 0 &&
                      this.state.warehouseData.map((warehouseData) => {
                        return (
                          <option value={warehouseData}>{warehouseData} </option>
                        );
                      })}
                  </select>
                  </div>
                  </div>

                    <div
                style={{ width: '13%', marginBottom: '0px', float: 'left', marginRight: 20, }}
              >
                <div
                  className="form__form-group-field"

                >
               <select
                    className="form-control"
                    style={{ fontSize: 13,  width: 190 }}
                    onChange={this.onHandleChange}
                    name="brand"
                  >
                    <option value="">Select Brand</option>
                    {
                      this.state.clientData.length > 0 &&
                      this.state.clientData.map((clientData) => {
                        return (
                          <option value={clientData}>{clientData} </option>
                        );
                      })}
                  </select>
                  </div>
                  </div>
              

            <div style={{ width: '11%', marginBottom: '0px', float: 'left' }}>
              <ButtonToolbar className="form__button-toolbar">
                <Button
                  className="btn-sm button_enable "
                  style={{
                    fontWeight: "normal",
                    textTransform: "capitalize",
                    borderRadius: 5,
                    backgroundColor: "#70bbfd",
                    color: "#fff",
                    padding: "5px 25px",
                    fontSize: "14px",
                  }}
                  id="button_enable"
                  onClick={() => this.fetchCycleCountData()}
                >
                  {this.state.loading && (
                    <i
                      className="fa fa-refresh fa-spin"
                      style={{ marginRight: "5px" }}
                    />
                  )}
                  Search
                </Button>
              </ButtonToolbar>
            </div>
            <div style={{ width: '3%', marginBottom: '0px', float: 'left' }}>
              <Button type="button" className="btn btn-primary-outline"
                style={{
                  cursor: this.state.btnDisabled ? 'pointer' : 'pointer',
                  backgroundColor: this.state.btnDisabled ? '#FFFFFF' : '#FFFFFF',
                }}
                id="button_enable"
                // onClick={this.downloadReport}
              >

                {/* <img src={require('../../../../images/download.png')} onClick={this.state.downloadError} /> */}
                <img src={require('../../../../images/download.png')}  onClick={(e) => this.downloadExcel()} />
              </Button>
            </div>

          </form>
          </CardBody>
          {
            this.state.showFetchBinData && (

              <CardBody className="cc_report_table" style={{ marginTop: 5 }}>
               
                
                <MDBDataTable
                style={{paddingTop: 0, marginTop: 0, top: 0}}
                  striped
                  bordered
                  scrollX
                  sortable={false}
                  hover
                  onSearch={this.filterData}
                  data={data}
        
                />
              </CardBody>
              

            )}

        </Card>

      </Col>
    );
  }
}

export default reduxForm({
  form: 'Upload Master', // a unique identifier for this form
})(withTranslation('common')(HorizontalForm));